import { render, staticRenderFns } from "./levelForm.vue?vue&type=template&id=47a20c30"
import script from "./levelForm.vue?vue&type=script&lang=js"
export * from "./levelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports